import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const fetchAgingReport = async function (filters) {
  try {
    const res = await axios.get(urls.getAgingReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchIncomeReport = async function (filters) {
  try {
    const res = await axios.get(urls.getIncomeReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchTaxRecap = async function (dateFrom, dateTo, customerId = null) {
  console.log('TCL: dateFrom, dateTo, customerId', dateFrom, dateTo, customerId)
  try {
    let data = {
      from: dateFrom,
      to: dateTo,
    }
    if (customerId) data.customerId = customerId
    const res = await axios.get(urls.getTaxRecap + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchDataArmadaReport = async function (filters) {
  try {
    const res = await axios.get(urls.getDataArmadaReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchProblemArmadaReport = async function (filters) {
  try {
    const res = await axios.get(urls.getProblemArmadaReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchOrderShipperReport = async function (filters) {
  try {
    const res = await axios.get(urls.getOrderShipperReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchBasp = async function (filters) {
  try {
    const res = await axios.get(urls.getListBasp + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchAgingReport,
  fetchIncomeReport,
  fetchTaxRecap,
  fetchDataArmadaReport,
  fetchProblemArmadaReport,
  fetchOrderShipperReport,
  fetchBasp,
}
